import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { BRAND } from "../lib/content";
import { SiteMenu } from "./SiteMenu";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        scrolled ? "border-b border-white/10 bg-ink/80 backdrop-blur-xl" : "bg-transparent"
      }`}
    >
      <span
        data-testid="nav-doc-series"
        className="pointer-events-none absolute inset-x-0 top-0 z-0 hidden h-[68px] translate-x-[6px] items-center justify-center whitespace-nowrap font-gothic text-xs uppercase tracking-[0.4em] text-flame sm:flex md:h-[76px] md:text-sm"
      >
        A Global Documentary Series
      </span>
      <nav className="relative mx-auto flex max-w-7xl items-center justify-between px-5 py-4 md:px-10">
        <Link to="/home" data-testid="nav-logo" className="relative z-10 flex items-center gap-3">
          <img src={BRAND.initials} alt="Tattooed Abroad" className="h-8 w-auto md:h-11" />
        </Link>

        <div className="relative z-10 flex items-center">
          <SiteMenu />
        </div>
      </nav>
    </header>
  );
};
